import Vue from 'vue';
import CircularCountDownTimer from 'vue-circular-count-down-timer';

Vue.use(CircularCountDownTimer);
